//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import comicobject from "./script/comicobject";
import recommand_rank from './index/recommand.rank'


export default {
  name: 'index',
  mixins: [comicobject],
  components: {
    recommand_rank
  },
  created() {
    window._t = this;
    this.listener_init = this.$hub.on('event:init', () => {
      this.japan_comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.japan.datas, this.ROW_COUNT, true);
      this.korean_comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.korean.datas, this.ROW_COUNT, true);
      this.$forceUpdate();
    });

    try {
      this.japan_comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.japan.datas, this.ROW_COUNT, true);
      this.korean_comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.korean.datas, this.ROW_COUNT, true);
    } catch (e) {
      console.log("e:", e)
    }
  },
  destroyed() {
    this.listener_init.off();
  },
  computed: {
    is_loading: function () {
      return !this.japan_comic_rows || !this.korean_comic_rows;
    }
  },
  data() {
    return {
      japan_comic_rows: undefined,
      korean_comic_rows: undefined,
      ROW_COUNT: this._g.COMMON_ROW_COUNT,
      g: this._g,
    }
  },
  watch: {
    "g.COMMON_ROW_COUNT": {
      handler(new_value, old_value) {
        this.ROW_COUNT = this._g.COMMON_ROW_COUNT;
        if (this.comic_list) {
          this.japan_comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.japan.datas, this.ROW_COUNT, true);
          this.korean_comic_rows = this.do_comic_list(this.$store.state.init.data.latest_datas.korean.datas, this.ROW_COUNT, true);
        }
      },
      immediate: true,
    },
  },
  metaInfo: {
    title: '首页',
  }
}
